<template>
    <el-dialog
        width="400px"
        title="选择发车单"
        v-dialogDrag
        :visible.sync="dispatchModalVisible"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="true"
        :before-close="beforeClose"
        :custom-class="'dispatchModal'">
        <el-radio-group v-model="dispatchNo">
            <el-radio
                v-for="(item, index) in dispatchNoList"
                :key="index"
                :label="item.dispatchNo"
                class="radio-item">
                {{ item.dispatchNo }}
            </el-radio>
        </el-radio-group>
        <div slot="footer">
            <el-button @click="beforeClose">取 消</el-button>
            <el-button type="primary" @click="handlePrint">打 印</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'dispatchModal',
    props: {
        dispatchModalVisible: {
            type: Boolean,
            default: false
        },
        dispatchNoList: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data () {
        return {
            dispatchNo: '',
            checkedData: {}
        };
    },
    created () {
        this.dispatchNo = this.dispatchNoList[0].dispatchNo;
    },
    methods: {
        beforeClose () {
            this.$emit('update:dispatchModalVisible', false);
        },
        handlePrint () {
            this.checkedData = this.dispatchNoList.find(item => item.dispatchNo === this.dispatchNo);
            this.$emit('openNewPrintDialog', this.checkedData);
        }
    }
};
</script>

<style lang="less">
.dispatchModal{
    margin-top: 10vh;
    .el-radio-group{
        max-height: 60vh;
        overflow-y: scroll;
        margin-left: 20px;
        width: 98%;
        .radio-item {
            display: block;
            line-height: 30px;
            .el-radio__inner{
                width: 16px;
                height: 16px;
            }
            .el-radio__label {
                font-size: 13px;
            }
        }
    }
}
</style>
